module.exports = __webpack_public_path__ + "img/jorge-castro-byn.a5fe7fb8.jpg";